<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      :overlay="false"
      class="Material"
      :close-on-popstate="true"
      :style="{
        width: '100%',
        height: 'calc(100% - 50px)',
        top: 0
      }"
    >
      <ld-header
        :title="title"
        @click-left="isShow = false"
      />
      <van-tabs
        v-model="active"
        line-width="20px"
        line-height="2px"
        animated
        swipeable
        sticky
      >
        <van-tab 
          v-for="(personType, j) in detail"
          :key="personType.crowdType"
          :title="personType.crowdTypeName"
          :name="j"
        >
          <!-- <van-cell-group
            v-for="(resoursType, index) in personType.contentBeans"
            :key="index"
            :title="resoursType.typeName"
          > -->
          <van-collapse
            v-model="activeName[j]"
            class="visaCollapse"
          >
            <van-collapse-item
              v-for="(content, i) in personType.contentBeans"
              :key="i"
              :name="i"
            >
              <div slot="title">
                {{ i + 1 }}、 {{ content.resourceName }} 
                <van-tag v-if="content.isYuanJian == 0">
                  复印件
                </van-tag>
                <van-tag
                  type="warning"
                  v-else-if="content.isYuanJian == 1"
                >
                  原件
                </van-tag>
                <van-tag
                  type="success"
                  v-else-if="content.isYuanJian == 2"
                >
                  彩色
                </van-tag>
              </div>
              <div
                class="pre-wrap"
                v-html="content.contents"
              />
            </van-collapse-item>
          </van-collapse>
          <!-- </van-cell-group> -->
        </van-tab>
      </van-tabs>
    </van-popup>
  </div>
</template>

<script>
import { CellGroup, Popup, Collapse, CollapseItem, Tag, Tabs, Tab } from 'vant'

export default {
  name: 'Material',
  components: {
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tag.name]: Tag,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab
  },
  data() {
    return {
      isShow: false,
      active: '1',
      activeName: [[''], [''], [''], [''], ['']]
    }
  },
  props: {
    pActive: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    detail: {
      type: [Array, Object],
      default: () => []
    },
    visibility: {
      type: Boolean,
      default: false
    }
  },
  // methods: {
  // 	changeTab (active) {
  // 		this.initCollapse(this.detail[active].contentBeans.length, active)
  // 	},
  // 	initCollapse (i, j) { // 默认展开折叠面板一列内容
  // 		this.activeName[j].splice(0, 1, i)
  // 		if (i < 0) return
  // 		this.$nextTick(() => {
  // 			this.initCollapse(--i, j)
  // 		})
  // 	}
  // },
  watch: {
    pActive (val) {
      this.active = val
    },
    visibility (val) {
      this.isShow = val
    },
    isShow (val) {
      this.$emit('update:visibility', val)
    }
  }
}
</script>

<style lang="less">
.Material {
  // Start 这里是为了Popup组件右滑下面留50像素显示预订栏bar，并且弹窗不会居中
  &.van-popup--right {
    transform: translate3d(0, 0, 0);
  }
  &.van-popup-slide-right-enter, &.van-popup-slide-right-leave-active {
    transform: translate3d(100%, 0, 0);
  }
  &.van-popup-slide-right-enter, &.van-popup-slide-right-leave-active {
    transform: translate3d(100%, 0, 0);
  }
  // End

  h4 {
    margin: 5px 0;
  }

  .pad8 {
    padding: 8px;
  }

  // .visaCollapse {
  //   .van-collapse-item {
  //     .van-collapse-item__wrapper {
  //       min-height: 45px !important;
  //       display: block !important;

  //       .van-collapse-item__content {
  //         padding: 4px 16px;
  //       }
  //     }
  //   }
  // }

}
</style>